import pengaturansoal from '../../../views/Kurikulum/Soal/PengaturanSoal.kurikulum.view';

export default pengaturansoal;